<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Customers Transactions</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <TransactionHistoryTable mode="customer-transactions" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * All Transaction History View
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import TransactionHistoryTable from "../../components/Kleyton/Tables/TransactionsHistory/TransactionHistoryTable";

export default {
  name: "CustomerTransactions",
  page: {
    title: "Customer Transactions",
    meta: [{ name: "Customer Transactions", content: window.__env.app.description }]
  },
  components: {
    TransactionHistoryTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Customer Transactions",

      items: [
        {
          text: "Customer Transactions",
          href: "/"
        },
        {
          text: "Customer Transactions",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
